module.exports = __webpack_public_path__ + "img/car.ea08cca6.png";